import React from "react";
import TextField from "@material-ui/core/TextField";
import {withStyles} from "@material-ui/styles";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Table from "@material-ui/core/Table";
import moment from "moment";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class ImsAuditChecklistHeader extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    handleChange(event) {
        if (this.props.onFieldChange) {
            this.props.onFieldChange(event.target.name, event.target.value);
        }
    }

    onDateChange(date, fieldName) {
        if (this.props.onFieldChange) {
            this.props.onFieldChange(fieldName, date ? moment(date, "DD/MM/YYYY") : null);
        }
    }

    render() {
        let state = this.props.state || {};
        return <React.Fragment>
            <Table>
                <tbody>
                <tr style={{ height: '50px', textAlign: 'left'}}>
                    <td style={{ 'width': '15%', fontWeight: 'bold', color: 'darkblue'}}>{ t('imsAuditChecklist.labels.dates') }</td>
                    <td>
                        <MuiPickersUtilsProvider utils={MomentUtils}><KeyboardDatePicker
                            disableToolbar
                            autoOk
                            variant="inline"
                            orientation="landscape"
                            format="DD/MM/YYYY"
                            margin="normal"
                            id="date1"
                            label={ t('context.common.date') }
                            name="date1"
                            value={state.date1}
                            onChange={(event) => this.onDateChange(event, 'date1')}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                        </MuiPickersUtilsProvider>
                    </td>
                </tr>
                <tr style={{ height: '50px', textAlign: 'left'}}>
                    <td style={{ 'width': '15%', fontWeight: 'bold', color: 'darkblue'}}></td>
                    <td>
                        <MuiPickersUtilsProvider utils={MomentUtils}><KeyboardDatePicker
                            disableToolbar
                            autoOk
                            variant="inline"
                            orientation="landscape"
                            format="DD/MM/YYYY"
                            margin="normal"
                            id="date2"
                            label={ t('context.common.date') }
                            name="date2"
                            value={state.date2}
                            onChange={(event) => this.onDateChange(event, 'date2')}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                        </MuiPickersUtilsProvider>
                    </td>
                </tr>
                <tr style={{ height: '50px', textAlign: 'left'}}>
                    <td style={{ 'width': '15%', fontWeight: 'bold', color: 'darkblue'}}></td>
                    <td>
                        <MuiPickersUtilsProvider utils={MomentUtils}><KeyboardDatePicker
                            disableToolbar
                            autoOk
                            variant="inline"
                            orientation="landscape"
                            format="DD/MM/YYYY"
                            margin="normal"
                            id="date3"
                            label={ t('context.common.date') }
                            name="date3"
                            value={state.date3}
                            onChange={(event) => this.onDateChange(event, 'date3')}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                        </MuiPickersUtilsProvider>
                    </td>
                </tr>
                <tr style={{ height: '50px', textAlign: 'left'}}>
                    <td style={{ 'width': '15%', fontWeight: 'bold', color: 'darkblue'}}></td>
                    <td>
                        <MuiPickersUtilsProvider utils={MomentUtils}><KeyboardDatePicker
                            disableToolbar
                            autoOk
                            variant="inline"
                            orientation="landscape"
                            format="DD/MM/YYYY"
                            margin="normal"
                            id="date4"
                            label={ t('context.common.date') }
                            name="date4"
                            value={state.date4}
                            onChange={(event) => this.onDateChange(event, 'date4')}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                        </MuiPickersUtilsProvider>
                    </td>
                </tr>
                <tr style={{ height: '50px'}}>
                    <td style={{ fontWeight: 'bold', color: 'darkblue' }}>{ t('imsAuditChecklist.labels.auditScope') }</td>
                    <td>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px"}}
                            id="scope"
                            value={state.scope}
                            label=""
                            name="scope"
                            onChange={ this.handleChange }
                            placeholder={ t('imsAuditChecklist.placeholders.scope') }
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                    </td>
                </tr>
                <tr style={{ height: '50px'}}>
                    <td style={{ fontWeight: 'bold', color: 'darkblue' }}>{ t('imsAuditChecklist.labels.auditor') }</td>
                    <td>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px"}}
                            id="auditor"
                            value={state.auditor}
                            label=""
                            name="auditor"
                            onChange={ this.handleChange }
                            placeholder={ t('imsAuditChecklist.placeholders.auditor') }
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                    </td>
                </tr>
                <tr style={{ height: '50px'}}>
                    <td style={{ fontWeight: 'bold', color: 'darkblue' }}>{ t('imsAuditChecklist.labels.location') }</td>
                    <td>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px"}}
                            id="location"
                            value={state.location}
                            label=""
                            name="location"
                            onChange={ this.handleChange }
                            placeholder={ t('imsAuditChecklist.placeholders.location') }
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                    </td>
                </tr>
                <tr style={{ height: '50px'}}>
                    <td style={{ fontWeight: 'bold', color: 'darkblue' }}>{ t('imsAuditChecklist.labels.auditee') }</td>
                    <td>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px"}}
                            id="auditee"
                            value={state.auditee}
                            label=""
                            name="auditee"
                            onChange={ this.handleChange }
                            placeholder={ t('imsAuditChecklist.placeholders.auditee') }
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        />
                    </td>
                </tr>
                </tbody>
            </Table>
        </React.Fragment>;
    }
}

export default withStyles(classes)(ImsAuditChecklistHeader);